"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberOfDecimals = exports.formatNumber = void 0;
const numeral_1 = __importDefault(require("numeral"));
function formatNumber(value, format, options = {}) {
    const { prefix = '', suffix = '', defaultFormat = '0.00' } = options;
    const formattedValue = (0, numeral_1.default)(value).format(format || defaultFormat);
    if (prefix || suffix) {
        return prefix + formattedValue + suffix;
    }
    return formattedValue;
}
exports.formatNumber = formatNumber;
function getNumberOfDecimals(value) {
    value = String(value).trim();
    const lastIndex = value.lastIndexOf('.');
    return lastIndex > 0 ? value.slice(lastIndex).split('').length - 1 : 0;
}
exports.getNumberOfDecimals = getNumberOfDecimals;
